
        <div [innerHTML]="contentLabels.reportClaim"></div>
